import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  return <AnimatePresence data-id="element-52">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 z-50 backdrop-blur-sm" data-id="element-53" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-54">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-zinc-900 border border-zinc-800 rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" data-id="element-55">
              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b border-zinc-800" data-id="element-56">
                <h2 className="text-xl font-serif text-white leading-[1.1]" data-id="element-57">
                  {title}
                </h2>
                <button onClick={onClose} className="text-zinc-400 hover:text-white transition-colors p-1" data-id="element-58">
                  <X className="w-5 h-5" data-id="element-59" />
                </button>
              </div>

              {/* Content */}
              <div className="p-5 overflow-y-auto max-h-[calc(80vh-80px)] text-zinc-300 text-sm leading-[1.5]" data-id="element-60">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}